import {
    closeDropdownMenusHandler,
    toggleDropdownHandler
} from './Handler';
import {CloseDropdownMenus} from './Event';

document.addEventListener('toggledropdownmenu', toggleDropdownHandler);
document.addEventListener('closedropdownmenus', closeDropdownMenusHandler);

document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
        document.dispatchEvent(new CloseDropdownMenus());
    }
});
